export default "__VITE_ASSET__36d4d01d__"